import { render, staticRenderFns } from "./AuditCertificate.vue?vue&type=template&id=4b8155f7"
import script from "./AuditCertificate.vue?vue&type=script&lang=js"
export * from "./AuditCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports